import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const PageTitle = styled.h4`
  color: #000;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px;
  margin-bottom: 16px;
  @media (max-width: 768px) {
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 35.2px;
  }
`

export const PageSubtitle = styled.p`
  color: #000;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 25.2px;
  }
`

export const GifBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 63px auto;
  margin-bottom: 10px;
  width: 400px;
  @media (max-width: 768px) {
    width: 289px;
    margin: 28px auto;
    margin-bottom: 5px;
  }
`
